/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataClipId } from "../../commons/types/DataClipId";
import { SheetId } from "../../commons/types/SheetId";
export const DataClip = core.serialization.object({
    id: DataClipId,
    name: core.serialization.string(),
    description: core.serialization.string().optional(),
    sourceSheetId: SheetId,
    clipSheetId: SheetId,
    workbookId: core.serialization.string(),
    status: core.serialization.string(),
    createdBy: core.serialization.string(),
    mergedAt: core.serialization.date().optional(),
    deletedAt: core.serialization.date().optional(),
    updatedAt: core.serialization.date(),
    createdAt: core.serialization.date(),
    guestLinkUrl: core.serialization.string().optional(),
    accessToken: core.serialization.string().optional(),
    sharedLinkAccess: core.serialization.string().optional(),
});
